import React, { useRef, useEffect, useState } from "react";
import emailjs from "emailjs-com";
import "./style.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";


const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState("");

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_unzvivf", 
        "template_440prr8", 
        form.current, 
        "FeH4L7jTif0nQVLSh"
      )
      .then(
        () => {
          const autoReplyParams = {
            from_name: form.current.name.value,
            from_email: form.current.email.value,
            project_type: form.current.subject.value,
          };

          emailjs.send(
            "service_unzvivf",
            "template_0pb34mw", // Your second auto-reply template ID
            autoReplyParams,
            "FeH4L7jTif0nQVLSh"
          );

          setStatus("Message sent successfully!");
          form.current.reset();
        },
        () => {
          setStatus("Failed to send message. Please try again.");
        }
      );
  };

  return (
    <div className="contact-body">
    <div className="contact-container" data-aos="fade-up">
      <Helmet>
              <title>Moonface Techs | Contact</title>
              <meta name="description" content="Moonface Techs - Contact Us for Custom ReactJS Web Development Solutions" />
            </Helmet>
      <h1>Contact Us</h1>
      <p>Have any questions or want to discuss a project? Get in touch!</p>

      <form ref={form} onSubmit={sendEmail} className="contact-form">
      <div className="form-group">
      <label htmlFor="name">Name</label>
      <input type="text" name="from_name" id="name" required />
      </div>

      <div className="form-group">
      <label htmlFor="email">Email</label>
      <input type="email" name="from_email" id="email" required />
      </div>

      <div className="form-group">
      <label htmlFor="subject">Subject</label>
      <input type="text" name="project_type" id="subject" required />
      </div>

      <div className="form-group">
      <label htmlFor="message">Message</label>
      <textarea name="message" id="message" required></textarea>
      </div>

      <button type="submit" className="submit-button">Send Message</button>

      {status && <p className="form-status">{status}</p>}
      </form>

      <div className="contact-info">
        <h2>Our Contact Details</h2>
        <p>Email: <a href="mailto:info@mftechs.co.za">info@mftechs.co.za</a></p>
        <p>Phone: <a href="tel:+27733758027">+27 73 375 8027</a></p>
      </div>
    </div>
    </div>
  );
};

export default Contact;
